import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import withErrorHandler from "component/design-system/withErrorHandler";
import { DELIVERY_METHODS } from "constant/action-constants";
import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";
import { useTranslation } from "next-i18next";
import HideIf from "util/HideIf";
import { selectedDeliveryMethodDetails } from "../helper/selectedDeliveryMethodDetails";
import styles from "./newDeliveryMethodSelector.module.scss";

interface IProps {
  deliveryMethod: string;
  availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[];
  textInGray?: boolean;
}

const EstimatedDeliveryDate = (props: IProps) => {
  const { deliveryMethod, availableDeliveryMethodsDetails, textInGray = false } = props;
  const selectedDeliveryMethod = selectedDeliveryMethodDetails(deliveryMethod, availableDeliveryMethodsDetails);

  if (!selectedDeliveryMethod) {
    return null;
  }

  const { minimumEstimatedDeliveryDate, maximumEstimatedDeliveryDate } = selectedDeliveryMethod;
  const { t } = useTranslation("shopping-cart");

  if (!minimumEstimatedDeliveryDate || !maximumEstimatedDeliveryDate) {
    return null;
  }
  let date = `${minimumEstimatedDeliveryDate} - ${maximumEstimatedDeliveryDate}`;
  if (minimumEstimatedDeliveryDate.split(" ")[0] === maximumEstimatedDeliveryDate.split(" ")[0]) {
    date = `${minimumEstimatedDeliveryDate} - ${maximumEstimatedDeliveryDate.split(" ")[1]}`;
  }

  return (
    <>
      <HideIf show={deliveryMethod === DELIVERY_METHODS.PICKUP}>
        <PAText fontSize={FONT_SIZE[0]} color="medium-grey">
          {`${t("Ready for Pickup")}`}
        </PAText>
      </HideIf>
      <HideIf show={deliveryMethod !== DELIVERY_METHODS.PICKUP} inlineBlock>
        <PAText fontSize={FONT_SIZE[0]} color="medium-grey">
          {`${t("Estimated Delivery")}`}
        </PAText>
      </HideIf>
      <PAText fontSize={FONT_SIZE[0]} color="medium-grey">
        {` ${t("By")}`}
      </PAText>
      <PAText
        fontSize={FONT_SIZE[0]}
        color={textInGray ? "medium-grey" : "black"}
        className={styles.delivery_date}
      >
        {` ${date}`}
      </PAText>

    </>
  );
};

export default withErrorHandler(EstimatedDeliveryDate);
